import { PageId } from 'constants/pages'

export const enum PageIdWoofzPupDrsl {
  DOG_AGE_PUP_DRSL = PageId.DOG_AGE_PUP_DRSL,
  DOG_OWNER_PUP_DRSL = PageId.DOG_OWNER_PUP_DRSL,
  TRAINING_COMMANDS_PUP_DRSL = PageId.TRAINING_COMMANDS_PUP_DRSL,
  URGE_PAGE_PUP_DRSL = PageId.URGE_PAGE_PUP_DRSL,
  DOG_BREED_PUP_DRSL = PageId.DOG_BREED_PUP_DRSL,
  FACING_CHALLENGES_PUP_DRSL = PageId.FACING_CHALLENGES_PUP_DRSL,
  FACING_CHALLENGES_2_PUP_DRSL = PageId.FACING_CHALLENGES_2_PUP_DRSL,
  BEHAVIOR_FREQUENCY_PUP_DRSL = PageId.BEHAVIOR_FREQUENCY_PUP_DRSL,
  URGE_PROGRAM_PUP_DRSL = PageId.URGE_PROGRAM_PUP_DRSL,
  BEHAVIOR_FEELINGS_PUP_DRSL = PageId.BEHAVIOR_FEELINGS_PUP_DRSL,
  FIX_BEHAVIOR_PUP_DRSL = PageId.FIX_BEHAVIOR_PUP_DRSL,
  URGE_PAGE_4_PUP_DRSL = PageId.URGE_PAGE_4_PUP_DRSL,
  COMMANDS_PUP_DRSL = PageId.COMMANDS_PUP_DRSL,
  PARENT_GOAL_PUP_DRSL = PageId.PARENT_GOAL_PUP_DRSL,
  TRAINING_PLACE_PUP_DRSL = PageId.TRAINING_PLACE_PUP_DRSL,
  TRAINING_FREQUENCY_PUP_DRSL = PageId.TRAINING_FREQUENCY_PUP_DRSL,
  URGE_PAGE_5_PUP_DRSL = PageId.URGE_PAGE_5_PUP_DRSL,
  PREPARE_FLOW_PUP_DRSL = PageId.PREPARE_FLOW_PUP_DRSL,
  EMAIL_PUP_DRSL = PageId.EMAIL_PUP_DRSL,
  NEWSLETTER_URGE_PUP_DRSL = PageId.NEWSLETTER_URGE_PUP_DRSL,
  LAST_CHANCE_OFFER_PUP_DRSL = PageId.LAST_CHANCE_OFFER_PUP_DRSL,
  SUBSCRIPTIONS_PUP_DRSL = PageId.SUBSCRIPTIONS_PUP_DRSL,
  CHAT_UPSELL_PUP_DRSL = PageId.CHAT_UPSELL_PUP_DRSL,
  UPSELL_PUP_DRSL = PageId.UPSELL_PUP_DRSL,
  UPSELL_FEEDING_GUIDE_PUP_DRSL = PageId.UPSELL_FEEDING_GUIDE_PUP_DRSL,
  UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL = PageId.UPSELL_EMOTIONAL_SUPPORT_PUP_DRSL,
  DOWNLOAD_PUP_DRSL = PageId.DOWNLOAD_PUP_DRSL,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
